var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-overlay"},[_c('div',{staticClass:"loading-spinner"}),_c('p',[_vm._v(_vm._s(_vm.$t('loading')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }